import { CHANGELOG_RESET, CHANGELOG_SET_CHANGELOGS, CHANGELOG_SET_CACHE_TIME } from '../mutation-types'

export const changelogStore = {
  namespaced: true,
  state: {
    /* API URLS */
    apiUrls: {
      changelog: 'changelog'
    },
    changelogs: [],
    cacheTime: 0 // in sec
  },
  mutations: {
    [CHANGELOG_RESET] (state) {
      state.changelogs = []
      state.cacheTime = 0
    },
    [CHANGELOG_SET_CHANGELOGS] (state, changelogList) {
      state.changelogs = changelogList
    },
    [CHANGELOG_SET_CACHE_TIME] (state) {
      state.cacheTime = Math.floor(new Date().getTime() / 1000)
    }
  },
  getters: {
    changelogUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.changelog
    }
  },
  actions: {
    // login an user
    async getChangelogs ({ state, commit, getters, dispatch, rootState }, payload) {
      // checkif cache is valid
      const currentTime = Math.floor(new Date().getTime() / 1000) // in sec
      if (state.changelogs.length > 0 && currentTime < (state.cacheTime + rootState.cacheTimeout)) {
        return true
      }
      // console.log('cache false')
      // set transport options
      const transportOptions = {
        method: 'get',
        data: { fakeData: true },
        url: getters.changelogUrl,
        withoutAuth: true
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        commit(CHANGELOG_SET_CHANGELOGS, response.data.changelogs)
        commit(CHANGELOG_SET_CACHE_TIME)
      } else {
        ret = false
      }

      return ret
    }
  }
}
